module.exports = "<mat-toolbar>\n  <button mat-icon-button (click)=\"openMenu.emit()\">\n    <mat-icon>menu</mat-icon>\n  </button>\n  <ng-content></ng-content>\n</mat-toolbar>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/toolbar/toolbar.component.html
// module id = ./src/app/components/toolbar/toolbar.component.html
// module chunks = main